import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { catchError, shareReplay } from "rxjs/operators";
import { AnalyticsGatewayHelper } from "./analytics-gateway-helper.service";

@Injectable({
  providedIn: "root",
})
export class LookerService {
  constructor(
    private gatewayHelper: AnalyticsGatewayHelper,
    private http: HttpClient,
  ) {}

  getLookerHost(apiVersion?: string): Observable<any> {
    const url: string = this.gatewayHelper.buildUnversionedGatewayUrl(
      environment.lookerHostPath,
      apiVersion,
    );
    return this.http.get(url).pipe(
      shareReplay(1),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }

  acquireEmbedSession(apiVersion: string): Observable<any> {
    const path: string =
      environment.reportsGateway[apiVersion].acquireEmbedSessionPath;
    const url: string = this.gatewayHelper.buildGatewayUrl(path, apiVersion);
    return this.http.get(url).pipe(
      shareReplay(1),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }

  generateEmbedTokens(apiVersion: string, tokens: any): Observable<any> {
    const path: string =
      environment.reportsGateway[apiVersion].generateEmbedTokensPath;
    const url: string = this.gatewayHelper.buildGatewayUrl(path, apiVersion);
    const headers = { "Content-Type": "application/json" };
    return this.http.put(url, tokens, { headers }).pipe(
      shareReplay(1),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }
}
